module.exports = __webpack_public_path__ + "static/img/8.9bed510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/8.png
// module id = EYwQ
// module chunks = 10